function Spinner({ color = "white", size = 50 }: { color?: string; size?: number | string }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            preserveAspectRatio="xMidYMid"
            style={{
                shapeRendering: "auto",
                display: "block",
            }}
            viewBox={`0 0 100 100`}
        >
            <circle
                cx={50}
                cy={50}
                r={25}
                fill="none"
                stroke={color}
                strokeDasharray="117.80972450961724 41.269908169872416"
                strokeWidth={4}
            >
                <animateTransform
                    attributeName="transform"
                    dur="1s"
                    keyTimes="0;1"
                    repeatCount="indefinite"
                    type="rotate"
                    values="0 50 50;360 50 50"
                />
            </circle>
        </svg>
    );
}

export default Spinner;
